import { render, staticRenderFns } from "./VariableIncomeAcquisition.vue?vue&type=template&id=6f69e1b9&scoped=true&"
import script from "./VariableIncomeAcquisition.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VariableIncomeAcquisition.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./VariableIncomeAcquisition.vue?vue&type=style&index=0&id=6f69e1b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f69e1b9",
  null
  
)

export default component.exports